import React, { useState, useEffect } from "react";
import { ChatBubble } from "./ChatBubble";
import { ChatPanel } from "./ChatPanel";
import { useProjectChat } from "./useProjectChat";

interface ProjectChatProps {
  projectId: string;
  projectName?: string;
}

export const ProjectChat: React.FC<ProjectChatProps> = ({
  projectId,
  projectName,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const chat = useProjectChat(projectId);

  // Mark as read when panel opens
  useEffect(() => {
    if (isOpen && chat.unreadCount > 0) {
      chat.markAsRead();
    }
  }, [isOpen, chat.unreadCount, chat.markAsRead]);

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      <ChatBubble
        unreadCount={chat.unreadCount}
        onClick={handleOpen}
        isOpen={isOpen}
      />
      <ChatPanel
        isOpen={isOpen}
        onClose={handleClose}
        chat={chat}
        projectName={projectName}
      />
    </>
  );
};

export default ProjectChat;
